module.exports = __webpack_public_path__ + "img/page1-bg.bc2211cc.png";